import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { CoreModule } from '../../../../core/core.module';
import { EventCellModule } from '../event-cell/event-cell.module';
import { NewTrackerModalModule } from '../new-tracker-modal/new-tracker-modal.module';
import { TrackerCellModule } from '../tracker-cell/tracker-cell.module';
import { DiaryTypeEditPopupComponent } from './component/diary-type-edit-popup/diary-type-edit-popup.component';
import { TrackerManagerComponent } from './tracker-manager.component';

@NgModule({
  declarations: [TrackerManagerComponent, DiaryTypeEditPopupComponent],
  imports: [
    CommonModule,
    EventCellModule,
    TrackerCellModule,
    NgxBootstrapIconsModule,
    NewTrackerModalModule,
    NgxInnerLoadingModule,
    TooltipModule,
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    DragulaModule,
  ],
  exports: [TrackerManagerComponent],
})
export class TrackerManagerModule {}
